export const ManualBondingStyle:React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "48px",
  alignSelf: "stretch",
  padding: "24px"
}

export const ManualBondingFilterStyle:React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "24px",
  alignSelf: "stretch",
  borderRadius: "8px",
  background: "#FFF",
}

export const ManualBondingFilterRow1Style:React.CSSProperties = {
  display: "flex",
  padding: "24px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "24px",
  alignSelf: "stretch",
  borderRadius: "8px",
  border: "1px solid #C5C6C5",
  background: "#FFF",
}

export const ManualBondingFilterRowElementStyle:React.CSSProperties = {
  display: "flex",
  paddingBottom: "0px",
  alignItems: "center",
  gap: "24px",
  alignSelf: "stretch",  
}

export const BulkPaymentEntryStyle:React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  gap: "48px",
  alignSelf: "stretch",
  marginLeft: "24px",
}

export const BulkPaymentEntryTitleSectionStyle:React.CSSProperties = {
  display: "flex",
  paddingBottom: "0px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "8px",
  alignSelf: "stretch",
}

export const BulkPaymentEntrySelectionStyle:React.CSSProperties = {
  display: "flex",
  width: "500px",
  paddingBottom: "0px",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  gap: "24px",
}